import React, { Component, Fragment } from 'react'
import { compose, withProps } from 'recompose'
import { translate } from '../Services/translation'
import resellerStyle from './ResellerGoogleMapStyle'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps'

const API_KEY = 'AIzaSyA-0Y1bOYeSmElvvtMBbyeRSY0XiNdbR9k'
const googleMapURL =
  `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${API_KEY}`;

export default class ResellerGoogleMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showingInfoWindow: false,
      defaultCenter: {},
      selectedMarker: {},
      selectedPlace: {},
      search: '',
      zoom: 5,
      zoomToMarkers: null,
      isZoomIn: false,
      currentMarkerCenter: { lat: 60.128162, lng: 18.643501 },
      isBusinessReseller: false,
      resellersData: ''
    }
    this.handleClick = this.handleClick.bind(this)
    this.onBtnClick = this.onBtnClick.bind(this)
    this.updateSearch = this.updateSearch.bind(this)
    this.getMyLocation = this.getMyLocation.bind(this)
    this.zoomMap = this.zoomMap.bind(this)
    this.FilterByType = this.FilterByType.bind(this)
  }
  zoomMap(marker, event) {
    this.setState({
      showingInfoWindow: false,
      selectedMarker: marker,
      currentMarkerCenter: {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      },
      zoom: 8,
      isZoomIn: true,
    })
  }
  componentDidUpdate() {
    this.getMyLocation()
  }
  onBtnClick(marker, event) {
    this.setState({
      showingInfoWindow: true,
      zoom: 8,
      isZoomIn: true,
    })
  }
  handleClick(marker, event) {
    this.setState({
      showingInfoWindow: false,
      selectedMarker: marker,
      currentMarkerCenter: {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      }
    })
  }
  updateSearch(event) {
    this.setState({
      zoom: 5,
      search: event.target.value.substr(0, 20)
    })
  }

  FilterByType(marker, event) {
    var filteredResellerByType;
    if (this.state.isBusinessReseller == false) {
      filteredResellerByType = this.props.resellerData.filter(reseller => {
        return (
          (
            reseller.type.toLowerCase().indexOf('p')
          ) !==
          -1
        )
      })
      this.setState({
        isBusinessReseller: true,
        resellersData: filteredResellerByType,
        zoom: 5
      })
    } else {
      filteredResellerByType = this.props.resellerData.filter(reseller => {
        return (
          (
            reseller.onlineReseller.toLowerCase().indexOf('false')
          ) !==
          -1
        )
      })
      this.setState({
        isBusinessReseller: false,
        resellersData: this.props.resellerData,
        zoom: 5
      })
    }
  }

  getMyLocation() {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          const coords = pos.coords
          this.setState({
            defaultCenter: {
              latitude: coords.latitude,
              longitude: coords.longitude
            },
            latitude: coords.latitude,
            longitude: coords.longitude
          })
        },
        error => {
          const el = document.getElementById('errorLabel');
          if (el) {
            el.value = error.message;
          }
        },
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
      )
    }
  }

  render() {
    if (this.state.isBusinessReseller == false) {
      this.state.resellersData = this.props.resellerData.filter(reseller => {
        return (
          (
            reseller.onlineReseller.toLowerCase().indexOf('false')
          ) !==
          -1
        )
      })
    } else {
      this.state.resellersData = this.props.resellerData.filter(reseller => {
        return (
          (
            reseller.type.toLowerCase().indexOf('p')
          ) !==
          -1
        )
      })
    }
    return (
      <div id="ResellersGoogleMap">
        <MapWithAMarker
          selectedMarker={this.state.selectedMarker}
          showingInfoWindow={this.state.showingInfoWindow}
          defaultCenter={this.state.defaultCenter}
          latitude={this.state.latitude}
          longitude={this.state.longitude}
          search={this.state.search}
          markers={this.state.resellersData}
          onClick={this.handleClick}
          onBtnClick={this.onBtnClick}
          updateSearch={this.updateSearch}
          zoomMap={this.zoomMap}
          zoomLevel={this.state.zoom}
          zoomToMarkers={this.state.zoomToMarkers}
          currentMarkerCenter={this.state.currentMarkerCenter}
          FilterByType={this.FilterByType}
        />
      </div>
    )
  }
}
const MapWithAMarker = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div id="LoadingElement" style={{ height: `100%`, padding: `61px 55px 55px 55px` }} />,
    // containerElement: <div id="Container" style={{ height: `85vh`, position: 'relative' }} />,
    containerElement: <div id="Container" style={{ height: `85vh`, width: `100%`, position: 'relative' }} />,

    mapElement: <div id="MapElement" style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  const onBtnClick = props.onBtnClick.bind(this)
  const updateSearch = props.updateSearch.bind(this)
  const zoomMap = props.zoomMap.bind(this)
  const FilterByType = props.FilterByType.bind(this)
  const resellers =
    !props.markers || props.markers.length === 0 ? (
      <div> </div>
    ) : (
        props.markers.filter(reseller => {
          return (
            (
              reseller.customerNumber.search(props.search) &&
              reseller.phone.search(props.search) &&
              reseller.zipCode.search(props.search) &&
              reseller.coordinates.search(props.search) &&
              reseller.address.toLowerCase().search(props.search.toLowerCase()) &&
              reseller.city.toLowerCase().search(props.search.toLowerCase()) &&
              reseller.name.toLowerCase().indexOf(props.search.toLowerCase())
            ) !==
            -1
          )
        })
      )
  return !props.markers || props.markers.length === 0 ? (
    <div> </div>
  ) : (

      <div className="google-map__wrapper">

        <div id="GoogleMap" className="google-map__list">
          <div className="google-map__list-container">
            <div className="google-map__input-wrapper">
              <i className="quick-search__icon" />

              <input
                type="search"
                className="google-map__input"
                placeholder={translate('reseller.search')}
                autoComplete="off"
                value={props.search}
                onChange={updateSearch}
              />

              <input type="label" id="errorLabel" style={{ display: 'none' }} />
              <div className="google-map__button-container google-map__button-container--location">
                <input
                  className="google-map__button"
                  type="button"
                  value={translate('reseller.nearme')}
                  onClick={onBtnClick}
                />
              </div>

            </div>
            <GoogleMap
              center={props.showingInfoWindow == true ? {
                lat: parseFloat(props.latitude),
                lng: parseFloat(props.longitude)
              } : props.currentMarkerCenter}
              zoom={props.zoomLevel}
              defaultOptions={{
                styles: resellerStyle
              }}
            >
              {props.showingInfoWindow == true && (
                <Marker
                  visible={props.showingInfoWindow}
                  zoom={props.zoomLevel}
                  center={props.defaultCenter}

                  position={{
                    lat: parseFloat(props.latitude),
                    lng: parseFloat(props.longitude)
                  }}
                >
                  <InfoWindow>
                    <div id="MyLocation">{'You are here!'}</div>
                  </InfoWindow>
                </Marker>
              )}

              {resellers.map(marker => {
                if (marker.lat != null) {
                  const onClick = props.onClick.bind(this, marker)
                  const zoomMap = props.zoomMap.bind(this, marker)
                  return (
                    //Marker on map
                    <Marker
                      key={marker.customerNumber}
                      onClick={onClick}
                      zoom={props.zoomLevel}
                      center={props.defaultCenter}
                      icon={props.selectedMarker === marker ? '/UI/images/markerselected.png' : '/UI/images/marker.png'}
                      position={{
                        lat: parseFloat(marker.lat),
                        lng: parseFloat(marker.lng)
                      }}
                    >
                      {/* marker InfoWindow */}
                      {props.selectedMarker === marker && (
                        <InfoWindow>
                          <div id="ResellersInfo">
                            <h1> {marker.name}</h1>
                            <br />
                            {marker.address}
                            <br />
                            {marker.zipcode} {marker.city}
                            <br />
                            {marker.phone
                              ? translate('phonenumberlabel') + ':'
                              : ''}{' '}
                            <a href={"tel:" + marker.phone}>{marker.phone}</a>
                          </div>
                        </InfoWindow>
                      )}
                      {/* ResellerList */}
                      <a onClick={zoomMap}>
                        <h3>{marker.name}</h3>
                        <h6>{marker.city}</h6>
                      </a>
                    </Marker>
                  )
                }
              })}

            </GoogleMap>

            {/* USE LATER
            <div className="bottom-toggle">
              <span>{translate('reseller.businessreseller')}</span>
              <div className="google-map__switch"> 
                <label className="switch">
                  <input type="checkbox" onClick={FilterByType} />
                  <span className="slider round"></span>
                </label>

              </div>
             </div>
            */}
          </div>
        </div>
      </div>
    )
})
